import { TabsMappingWidget } from "@/pages-components/products/digital-offset-price/widgets/tabs-mapping";
import {
  GomakePrimaryButton,
  GoMakeDialog,
  GomakeTextInput,
} from "@/components";
import { useAddProduct } from "@/hooks";
import { usePcScreenMarker } from "@/hooks/use-pc-screen-marker";
import { ChildParameterModal } from "../child-parameter-modal";
import { useStyle } from "./style";
import { Tabs } from "@mui/material";
import { AccordionMappingWidget } from "./widgets/accordion-mapping";
import { SectionMappingWidget } from "./widgets/section-mapping";
import { GalleryModal, MultiParameterModal } from "../../digital-offset-price";
import { PrintingColorsOptionsModal } from "../../digital-offset-price/multi-parameter-modal/printing-colors-options-modal";
import { RollDirectionOptionsModal } from "../../digital-offset-price/multi-parameter-modal/roll-direction-options-modal";
import { UpdateParameterModal } from "./widgets/update-parameter-modal";
import { ExternalValuesIdModal } from "../external-ids-modal";
import { useState } from "react";
import { IconButton, Stack, Typography } from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
import { useRouter } from "next/router";
import { AddTemplateSectionDialog, AddTemplateSubSectionDialog } from "./template-section-dialogs";
import { useTheme } from "@/contexts/theme";

const ParameterWidget = () => {
  const { classes } = useStyle();
  const isModern = useTheme().currentTheme === "modern";
  const screenMarkerRef = usePcScreenMarker(isModern);
  const {
    setSelectedParameter,
    onCloseModal,
    _renderParameterType,
    onOpenModal,
    t,
    handleTabClick,
    handleNextClick,
    handleCalculateProductVariations,
    handleConfirmCalculateProductVariations,
    handleCloseVariationsSummaryModal,
    handlePreviousClick,
    updatedProductParameterHidden,
    updatedProductParameterAiSuggestion,
    confirmValueConfigModalUpdate,
    updatedProductParameterShowToClient,
    saveTemplateParameterSettings,
    updatedProductParameterTranslations,
    updatedProductParameteRequierd,
    updatedProductParameteLocked,
    updatedValuesConfigsForParameters,
    setTemplate,
    getProductById,
    activeIndex,
    template,
    selectedSubSection,
    selectedSectonId,
    selectedOption,
    selectedSubSectionId,
    selectedParameter,
    openModal,
    expanded,
    handleChange,
    relatedParameters,
    GalleryModalOpen,
    onCloseGalleryModal,
    straightKnife,
    multiParameterModal,
    onCloseMultiParameterModal,
    colorOptionsModalOpen,
    onCloseColorOptionsModal,
    onOpenColorOptionsModal,
    rollDirectionOptionsModalOpen,
    onCloseRollDirectionOptionsModal,
    onOpenRollDirectionOptionsModal,
    setSettingParameters,
    settingParameters,
    isMaterialParameter,
    setSelectedUpdateType,
    selectedUpdateType,
    handleCloseModal,
    isUpdateModalOpen,
    isUpdatingParameter,
    setDoNotAskNextTime,
    doNotAskNextTime,
    selectedSectionId,
    onOpenExternalIdsModal,
    onCloseExternalIdsModal,
    openExternalIdsModal,
    removeProductParamete,
    productState,
    addSubSectionToProduct,
    isVariationProductMode,
    isCalculatingVariations,
    isConfirmingVariations,
    isVariationsSummaryModalOpen,
    productVariationsSummary,
    addSectionToTemplate,
    updateSectionOnTemplate,
    updateSubSectionOnTemplate,
    deleteSectionFromTemplate,
    deleteSubSectionFromTemplate,
    addSubSectionToTemplate,
    queueAddExistingParameterToTemplate,
    savePendingTemplateParameters,
    pendingTemplateParameterCount,
    savingTemplateParameters,
  } = useAddProduct({ classes });
  const router = useRouter();
  const isTemplateEdit = router.asPath?.includes("/settings/templates/");

  const [isAddSectionDialogOpen, setIsAddSectionDialogOpen] = useState(false);
  const [editingSection, setEditingSection] = useState<any>(null);
  const [editingSubSection, setEditingSubSection] = useState<any>(null);
  const [isTemplateSubSectionOpen, setIsTemplateSubSectionOpen] = useState(false);
  const [isAddSubSectionDialogOpen, setIsAddSubSectionDialogOpen] =
    useState(false);
  const [subSectionName, setSubSectionName] = useState("");
  const [selectedSectionIdForSubSection, setSelectedSectionIdForSubSection] =
    useState<string | null>(null);

  const visibleSections = Array.isArray(template?.sections)
    ? template.sections
    : [];
  const CUSTOM_PRODUCT_TEMPLATE_ID = "a4b096a5-cf5a-4b72-a101-c79f5eccfef8";
  const isCustomProduct =
    productState?.templateId === CUSTOM_PRODUCT_TEMPLATE_ID ||
    (typeof productState?.templateId === "object" &&
      productState?.templateId?.id === CUSTOM_PRODUCT_TEMPLATE_ID);

  const handleOpenAddSubSectionDialog = (sectionId: string) => {
    setSelectedSectionIdForSubSection(sectionId);
    setSubSectionName("");
    setIsAddSubSectionDialogOpen(true);
  };

  const handleCloseAddSubSectionDialog = () => {
    setIsAddSubSectionDialogOpen(false);
    setSubSectionName("");
    setSelectedSectionIdForSubSection(null);
  };

  const handleAddSubSection = () => {
    if (!subSectionName.trim()) {
      return;
    }
    if (selectedSectionIdForSubSection) {
      addSubSectionToProduct(
        selectedSectionIdForSubSection,
        subSectionName.trim()
      );
      handleCloseAddSubSectionDialog();
    }
  };

  return (
    <>
      {template && (
        <>
          <div ref={screenMarkerRef} style={classes.mainRowContainer}>
            <div
              className={isModern ? "gm-pc" : undefined}
              style={classes.leftSideContainer}
            >
              <div
                className={isModern ? "gm-pc-steps" : undefined}
                style={classes.tabsContainer}
              >
                <Tabs variant="scrollable" scrollButtons={"auto"}>
                  {visibleSections.map((item, index) => {
                    return (
                      <TabsMappingWidget
                        key={`tab-${index}`}
                        classes={classes}
                        index={index}
                        handleTabClick={handleTabClick}
                        activeIndex={activeIndex}
                        productTemplate={template}
                        setProductTemplate={setTemplate}
                        item={item}
                        isAdmin={true}
                        getProductById={getProductById}
                        onEditTemplateSection={
                          isTemplateEdit
                            ? (section) => {
                                setEditingSection(section);
                                setIsAddSectionDialogOpen(true);
                              }
                            : undefined
                        }
                        onDeleteTemplateSection={isTemplateEdit ? deleteSectionFromTemplate : undefined}
                      />
                    );
                  })}
                </Tabs>
                {isTemplateEdit && (
                  <IconButton
                    aria-label={t("products.addProduct.admin.addSection", { defaultValue: "Add section" })}
                    onClick={() => {
                      setEditingSection(null);
                      setIsAddSectionDialogOpen(true);
                    }}
                  >
                    <AddIcon />
                  </IconButton>
                )}
              </div>
              <div
                className={
                  isModern ? "custom-scrollbar gm-pc-form" : "custom-scrollbar"
                }
                style={{ height: "55vh", overflow: "auto", width: "100%" }}
              >
                <div
                  className={isModern ? "gm-settings-sections" : undefined}
                  style={classes.sectionsContainer}
                >
                  {visibleSections.map((section, index) => {
                    if (index === activeIndex) {
                      const showAddSubSectionButton = isCustomProduct || isTemplateEdit;

                      return (
                        <div key={`section-${index}`}>
                          {showAddSubSectionButton && (
                            <div
                              style={{
                                marginBottom: "20px",
                              }}
                            >
                              <GomakePrimaryButton
                                onClick={() => {
                                  if (isTemplateEdit) {
                                    setEditingSubSection(null);
                                    setSelectedSectionIdForSubSection(section?.id);
                                    setIsTemplateSubSectionOpen(true);
                                    return;
                                  }
                                  handleOpenAddSubSectionDialog(section?.id);
                                }}
                                style={{
                                  minWidth: "200px",
                                  maxWidth: "200px",
                                  height: "40px",
                                }}
                              >
                                {t("products.addProduct.admin.addSubSection") ||
                                  "Add SubSection"}
                              </GomakePrimaryButton>
                            </div>
                          )}
                          {section?.subSections?.map((subSection, subIndex) => {
                            if (subSection?.isAccordion) {
                              return (
                                <AccordionMappingWidget
                                  key={`accordion-${subIndex}`}
                                  index={subIndex}
                                  expanded={expanded}
                                  classes={classes}
                                  handleChange={handleChange}
                                  subSection={subSection}
                                  onOpenModal={onOpenModal}
                                  onOpenExternalIdsModal={
                                    onOpenExternalIdsModal
                                  }
                                  section={section}
                                  updatedProductParameterHidden={
                                    updatedProductParameterHidden
                                  }
                                  updatedProductParameterAiSuggestion={
                                    updatedProductParameterAiSuggestion
                                  }
                                  updatedProductParameterShowToClient={
                                    updatedProductParameterShowToClient
                                  }
                                  updatedProductParameteRequierd={
                                    updatedProductParameteRequierd
                                  }
                                  updatedProductParameteLocked={
                                    updatedProductParameteLocked
                                  }
                                  _renderParameterType={_renderParameterType}
                                  relatedParameters={relatedParameters}
                                  getProductById={getProductById}
                                  removeProductParamete={removeProductParamete}
                                  saveTemplateParameterSettings={isTemplateEdit ? saveTemplateParameterSettings : undefined}
                                  updatedProductParameterTranslations={updatedProductParameterTranslations}
                                  queueAddExistingParameterToTemplate={queueAddExistingParameterToTemplate}
                                  onEditSubSection={
                                    isTemplateEdit
                                      ? (subSection) => {
                                          setSelectedSectionIdForSubSection(section?.id);
                                          setEditingSubSection(subSection);
                                          setIsTemplateSubSectionOpen(true);
                                        }
                                      : undefined
                                  }
                                  deleteSubSectionFromTemplate={isTemplateEdit ? deleteSubSectionFromTemplate : undefined}
                                  isVariationProductMode={isVariationProductMode}
                                  onOpenColorOptionsModal={onOpenColorOptionsModal}
                                  onOpenRollDirectionOptionsModal={
                                    onOpenRollDirectionOptionsModal
                                  }
                                />
                              );
                            } else {
                              return (
                                <SectionMappingWidget
                                  key={`section-mapping-${subIndex}`}
                                  index={subIndex}
                                  classes={classes}
                                  subSection={subSection}
                                  onOpenModal={onOpenModal}
                                  onOpenExternalIdsModal={
                                    onOpenExternalIdsModal
                                  }
                                  section={section}
                                  updatedProductParameterHidden={
                                    updatedProductParameterHidden
                                  }
                                  updatedProductParameterAiSuggestion={
                                    updatedProductParameterAiSuggestion
                                  }
                                  updatedProductParameterShowToClient={
                                    updatedProductParameterShowToClient
                                  }
                                  updatedProductParameteRequierd={
                                    updatedProductParameteRequierd
                                  }
                                  updatedProductParameteLocked={
                                    updatedProductParameteLocked
                                  }
                                  _renderParameterType={_renderParameterType}
                                  relatedParameters={relatedParameters}
                                  getProductById={getProductById}
                                  removeProductParamete={removeProductParamete}
                                  saveTemplateParameterSettings={isTemplateEdit ? saveTemplateParameterSettings : undefined}
                                  updatedProductParameterTranslations={updatedProductParameterTranslations}
                                  queueAddExistingParameterToTemplate={queueAddExistingParameterToTemplate}
                                  onEditSubSection={
                                    isTemplateEdit
                                      ? (subSection) => {
                                          setSelectedSectionIdForSubSection(section?.id);
                                          setEditingSubSection(subSection);
                                          setIsTemplateSubSectionOpen(true);
                                        }
                                      : undefined
                                  }
                                  deleteSubSectionFromTemplate={isTemplateEdit ? deleteSubSectionFromTemplate : undefined}
                                  isVariationProductMode={isVariationProductMode}
                                  onOpenColorOptionsModal={onOpenColorOptionsModal}
                                  onOpenRollDirectionOptionsModal={
                                    onOpenRollDirectionOptionsModal
                                  }
                                />
                              );
                            }
                          })}
                        </div>
                      );
                    }
                    return null;
                  })}
                </div>
              </div>
            </div>
          </div>
          <div style={classes.addPreviousContainer}>
            {isVariationProductMode ? (
              <GomakePrimaryButton
                style={classes.nextBtnStyle}
                onClick={handleCalculateProductVariations}
                disabled={isCalculatingVariations}
              >
                {t("products.offsetPrice.admin.calculateVariations", { defaultValue: "Calculate" })}
              </GomakePrimaryButton>
            ) : (
              <>
                {activeIndex != 0 ? (
                  <GomakePrimaryButton
                    style={classes.previousBtnStyle}
                    onClick={handlePreviousClick}
                  >
                    {t("products.offsetPrice.admin.previousBtn")}
                  </GomakePrimaryButton>
                ) : null}
                {isTemplateEdit ? (
                  <GomakePrimaryButton
                    style={{ width: 110, height: "var(--theme-button-height, 40px)" }}
                    onClick={savePendingTemplateParameters}
                    disabled={!pendingTemplateParameterCount || savingTemplateParameters}
                  >
                    {t("products.addProduct.admin.updateParameters", { defaultValue: "Update" })}
                  </GomakePrimaryButton>
                ) : null}
                {visibleSections.length - 1 != activeIndex ? (
                  <GomakePrimaryButton
                    style={classes.nextBtnStyle}
                    onClick={handleNextClick}
                  >
                    {t("products.offsetPrice.admin.nextBtn")}
                  </GomakePrimaryButton>
                ) : null}
              </>
            )}
          </div>
          <ChildParameterModal
            openModal={openModal}
            onClose={onCloseModal}
            selectedParameter={selectedParameter}
            modalTitle={`${selectedParameter?.name} values`}
            selectedSectonId={selectedSectonId}
            selectedSubSection={selectedSubSection}
            setSelectedParameter={setSelectedParameter}
            updatedValuesConfigsForParameters={
              updatedValuesConfigsForParameters
            }
            _renderParameterType={_renderParameterType}
          />
          <ExternalValuesIdModal
            openModal={openExternalIdsModal}
            onClose={onCloseExternalIdsModal}
            parameter={selectedParameter}
            sectionId={selectedSectonId}
            subSectionId={selectedSubSection}
            getProductById={getProductById}
          />
        </>
      )}
      <GalleryModal
        openModal={GalleryModalOpen}
        onClose={onCloseGalleryModal}
        isParameterSettings={true}
        straightKnife={straightKnife}
        getProductById={getProductById}
        template={template}
      />
      <MultiParameterModal
        openModal={multiParameterModal}
        onClose={onCloseMultiParameterModal}
        settingParameters={settingParameters}
        _renderParameterType={_renderParameterType}
        isParameterSettings={true}
        setSettingParameters={setSettingParameters}
        getProductById={getProductById}
      />
      <PrintingColorsOptionsModal
        openModal={colorOptionsModalOpen}
        onClose={onCloseColorOptionsModal}
        modalTitle={`${selectedParameter?.name ?? ""} ${t("products.offsetPrice.admin.options", { defaultValue: "options" })}`}
        selectedParameter={selectedParameter}
        selectedSectonId={selectedSectonId}
        selectedSubSection={selectedSubSection}
        updatedValuesConfigsForParameters={updatedValuesConfigsForParameters}
      />
      <RollDirectionOptionsModal
        openModal={rollDirectionOptionsModalOpen}
        onClose={onCloseRollDirectionOptionsModal}
        modalTitle={`${selectedParameter?.name ?? ""} ${t("documentingDesign.Additional.Options",)}`}
        selectedParameter={selectedParameter}
        selectedSectonId={selectedSectonId}
        selectedSubSection={selectedSubSection}
        updatedValuesConfigsForParameters={updatedValuesConfigsForParameters}
      />
      {!isVariationProductMode && !isTemplateEdit && (
        <UpdateParameterModal
          openModal={isUpdateModalOpen}
          onClose={handleCloseModal}
          selectedUpdateType={selectedUpdateType}
          setSelectedUpdateType={setSelectedUpdateType}
          onUpdate={() => void confirmValueConfigModalUpdate()}
          setDoNotAskNextTime={setDoNotAskNextTime}
          doNotAskNextTime={doNotAskNextTime}
          isLoading={isUpdatingParameter}
        />
      )}
      <GoMakeDialog
        open={isAddSubSectionDialogOpen}
        onClose={handleCloseAddSubSectionDialog}
        title={t("products.addProduct.admin.addSubSection") || "Add SubSection"}
        onPrimaryAction={handleAddSubSection}
        primaryButtonLabel={t("sales.quote.add")}
        cancelButtonLabel={t("modal.cancel")}
        primaryButtonDisabled={!subSectionName.trim()}
        maxWidth="sm"
        fullWidth
      >
        <Stack gap={2} paddingTop={"10px"}>
          <div>
            <div style={{ fontSize: 14, fontWeight: 600, marginBottom: 8 }}>
              {t("products.addProduct.admin.subSectionName") ||
                "SubSection Name"}
            </div>
            <GomakeTextInput
              value={subSectionName}
              onChange={(e: any) => setSubSectionName(e.target.value)}
              placeholder={
                t("products.addProduct.admin.enterSubSectionName") ||
                "Enter SubSection Name"
              }
              style={{ width: "100%", height: "40px" }}
            />
          </div>
        </Stack>
      </GoMakeDialog>
      {isVariationProductMode ? (
        <GoMakeDialog
          open={isVariationsSummaryModalOpen}
          onClose={handleCloseVariationsSummaryModal}
          title={t("products.offsetPrice.admin.variationsSummaryTitle", {
            defaultValue: "Product variations summary",
          })}
          onPrimaryAction={handleConfirmCalculateProductVariations}
          primaryButtonLabel={t("settings.confirm")}
          cancelButtonLabel={t("modal.cancel")}
          primaryButtonLoading={isConfirmingVariations}
          primaryButtonDisabled={isConfirmingVariations}
          maxWidth="md"
          fullWidth
        >
          <Stack gap={1} paddingTop="10px">
            <Typography
              component="pre"
              sx={{
                fontFamily: "inherit",
                fontSize: 14,
                whiteSpace: "pre-wrap",
                margin: 0,
              }}
            >
              {productVariationsSummary}
            </Typography>
          </Stack>
        </GoMakeDialog>
      ) : null}
      <AddTemplateSectionDialog
        open={isAddSectionDialogOpen}
        sections={visibleSections}
        initial={editingSection}
        onClose={() => {
          setIsAddSectionDialogOpen(false);
          setEditingSection(null);
        }}
        onSave={(section) => {
          if (editingSection?.id) updateSectionOnTemplate(section);
          else addSectionToTemplate(section);
          setIsAddSectionDialogOpen(false);
          setEditingSection(null);
        }}
      />
      <AddTemplateSubSectionDialog
        open={isTemplateSubSectionOpen}
        initial={editingSubSection}
        onClose={() => {
          setIsTemplateSubSectionOpen(false);
          setEditingSubSection(null);
        }}
        onSave={(subSection) => {
          if (selectedSectionIdForSubSection && editingSubSection?.id) {
            updateSubSectionOnTemplate(selectedSectionIdForSubSection, subSection);
          } else if (selectedSectionIdForSubSection) {
            addSubSectionToTemplate(selectedSectionIdForSubSection, subSection);
          }
          setIsTemplateSubSectionOpen(false);
          setEditingSubSection(null);
        }}
      />
    </>
  );
};

export { ParameterWidget };
